import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import toast from 'react-hot-toast';

const ContactForm = () => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    try {
      const emailData = {
        // to: 'customer.services@jobya.pro',
        subject: `Contact Form: ${data.subject}`,
        html: `
          <h3>New Contact Form Submission</h3>
          <p><strong>Name:</strong> ${data.name}</p>
          <p><strong>Email:</strong> ${data.email}</p>
          <p><strong>Subject:</strong> ${data.subject}</p>
          <p><strong>Message:</strong></p>
          <p>${data.message.replace(/\n/g, '<br>')}</p>
        `
      };

      // Use URL absoluta em desenvolvimento, relativa em produção
      const apiUrl = process.env.NODE_ENV === 'development' 
        ? 'http://localhost:3001/api/send-email'
        : '/api/send-email';
      
      await axios.post(apiUrl, emailData);

      toast.success(t('contact.success'));
      reset();
    } catch (error) {
      console.error('Error sending email:', error);
      
      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
        toast.error(`${t('contact.error')}: ${error.response.data.message || error.response.status}`);
      } else if (error.request) {
        console.error('Request error:', error.request);
        toast.error(`${t('contact.error')}: No response from server`);
      } else {
        console.error('Error message:', error.message);
        toast.error(`${t('contact.error')}: ${error.message}`);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="contact-form">
      <div className="form-group">
        <label htmlFor="name">{t('contact.name')}</label>
        <input
          type="text"
          id="name"
          {...register('name', { required: true })}
        />
        {errors.name && <span className="error">This field is required</span>}
      </div>

      <div className="form-group">
        <label htmlFor="email">{t('contact.email')}</label>
        <input
          type="email"
          id="email"
          {...register('email', {
            required: true,
            pattern: /^\S+@\S+$/i
          })}
        />
        {errors.email && <span className="error">Please enter a valid email</span>}
      </div>

      <div className="form-group">
        <label htmlFor="subject">{t('contact.subject')}</label>
        <input
          type="text"
          id="subject"
          {...register('subject', { required: true })}
        />
        {errors.subject && <span className="error">This field is required</span>}
      </div>

      <div className="form-group">
        <label htmlFor="message">{t('contact.message')}</label>
        <textarea
          id="message"
          {...register('message', { required: true })}
        ></textarea>
        {errors.message && <span className="error">This field is required</span>}
      </div>

      <button
        type="submit"
        className="btn btn-primary"
        disabled={isSubmitting}
      >
        {isSubmitting ? t('contact.sending') : t('contact.send')}
      </button>
    </form>
  );
};

export default ContactForm;
